import styled from 'styled-components';
import { StyledEntityItem } from 'components/Global/EntityItem/styled.js';

export const StyledEntityLogoBox = styled.div`
  padding-top: 20px;
  padding-left: 29px;

  ${StyledEntityItem} {
    font-size: 14px;
    color: #131F2B;
  }
`;
